import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const mapsOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.MAPS,
    steps: [
        {
            id: "maps-welcome",
            title: "Mapa Interativo",
            description:
                "Visualize em tempo real a posição dos motoristas online e as áreas de maior demanda.",
            position: "center",
        },
        {
            id: "maps-heatmap",
            title: "Mapa de Calor",
            description:
                "O mapa de calor mostra onde há maior concentração de corridas, ajudando a identificar regiões de alta demanda.",
            targetId: "maps-heatmap",
            position: "bottom",
        },
        {
            id: "maps-filters",
            title: "Filtros do Mapa",
            description:
                "Use os filtros para ver motoristas por status (online/offline), tipo de veículo ou período específico.",
            targetId: "maps-filters",
            position: "bottom",
        },
    ],
};
